import { IIdAndNamePair } from '../../../../../models/Common';
import { SelectOption } from '../types';
import { CLIENT_ACCOUNT_TYPE, INTERNAL_ACCOUNT_TYPE } from '../constant';

export const mapToSelectOptions = (items: IIdAndNamePair[]): SelectOption[] =>
    items.map(({ name, id }) => ({
        value: String(id),
        label: name.replace(/_/g, ' '), 
    }));

/**
 * Maps legacy account types to simplified Client (1) or Internal (2) types
 * @param accountType - The legacy account type ID
 * @returns The simplified account type ID
 */
export const getInitialAccountType = (accountType: number): typeof CLIENT_ACCOUNT_TYPE | typeof INTERNAL_ACCOUNT_TYPE => {
    const translateMap = {
        1: CLIENT_ACCOUNT_TYPE,
        2: INTERNAL_ACCOUNT_TYPE,
        3: CLIENT_ACCOUNT_TYPE,
        4: CLIENT_ACCOUNT_TYPE,
        5: CLIENT_ACCOUNT_TYPE,
        8: INTERNAL_ACCOUNT_TYPE,
    } as const;

    return translateMap[accountType as keyof typeof translateMap] ?? CLIENT_ACCOUNT_TYPE;
};
